module.exports = __webpack_public_path__ + "media/madeca-medium.8debc541.mp4";